<template>

  <a-tooltip
    placement="top"
    class="user_action"
  >
    <template #title v-if="props.tooltip">
      <span>
        {{ props.tooltip }}
      </span>
    </template>
    <a-switch 
      :checked="record.status === 1" 
      @update:checked="handleToggle" 
      size="small"
      :disabled="props.disabled"
    />
  </a-tooltip>

  <inactive-user-modal
    v-if="record.role?.name === 'Administrador' && record.assigned_contacts === 0"
    :visible="visibleInactive"
    :record="record"
    @onCancel="handleCancelInactive"
    @update="
      emit('update');
      handleMessage();
    "
  />

  <inactive-agent-modal
    v-if="record.role?.name === 'Agente' && record.assigned_contacts === 0"
    :visible="visibleInactive"
    :record="record"
    @onCancel="handleCancelInactive"
    @update="
      emit('update');
      handleMessage();
    "
  />

  <inactive-agent-assigned
    v-if="record.assigned_contacts > 0"
    :visible="visibleInactive"
    :record="record"
    @onCancel="handleCancelInactive"
    @update="
      emit('update');
      handleMessage();
    "
  />
</template>

<script setup>
import { createVNode, h, ref } from "vue";
import { Modal, message } from "ant-design-vue";
import { ExclamationCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { useStore } from "vuex";

import { UserStatus } from "@/app/shared/utils/enums";

import InactiveUserModal from "@/app/users/components/modals/InactiveUserModal.vue";
import InactiveAgentModal from "@/app/users/components/modals/InactiveAgentModal.vue";
import InactiveAgentAssigned from "@/app/users/components/modals/InactiveAgentAssigned.vue";

const props = defineProps({ 
  record: { default: () => ({}) },
  disabled: { default: false },
  tooltip: { default: null },
});

const emit = defineEmits(["update", "openBuyModal"]);

const store = useStore();

const visibleInactive = ref(false);

const handleMessage = () => {
  message.success("Se inactivó correctamente un usuario. Se ha liberado 1 slot.");
};

const handleToggle = (checked) => {
  if (!checked) {
    visibleInactive.value = true;
    return;
  }

  const name = props.record.first_name;
  const fullName = `${name.length !== 0 ? name : props.record.email} ${props.record.last_name}`;
  const title = `¿Estás seguro de reactivar a ${fullName}?`;

  Modal.confirm({
    title: title,
    content:
      "Recuerda que el usuario podrá volver a acceder a la plataforma y se consumirá un nuevo slot.",
    icon: createVNode(QuestionCircleOutlined),
    onOk: async () => {
      try {
        await store.dispatch("updateUser", {
          id: props.record.id,
          params: { status: UserStatus.active },
        });

        emit("update");
        message.success("Se reactivó correctamente un usuario. Se ha consumido 1 slot disponible.");
      } catch (error) {
        if (error.status === 400) {
          const message = error.data.errors;
          const stateError = "No se puede activar al usuario en estado pendiente";
          const slotsError = "No se puede activar al usuario porque no tiene slots disponibles.";
          const slotsContent =
            "Actualmente, estás utilizando todos tus slots adquiridos. Para reactivar a este usuario, te recomendamos comprar slots adicionales. También puedes inactivar o eliminar a un usuario de tu plataforma para liberar un slot.";
          const content = message[0] === stateError ? "" : slotsContent;
          const showSlotPayment = message[0] === slotsError;
          const cancelButtonProps = message[0] === stateError ? { style: { display: "none" } } : {};
          Modal.confirm({
            centered: true,
            icon: h(ExclamationCircleOutlined),
            title: message[0],
            content: content,
            okText: showSlotPayment ? "Comprar slots" : "Aceptar",
            onOk: () => showSlotPayment && emit("openBuyModal", 1),
            cancelButtonProps: cancelButtonProps,
          });
        } else {
          message.error("Ha ocurrido un error");
        }
      }
    },
    centered: true,
    okText: "Reactivar",
    cancelText: "Cancelar",
  });
};

const handleCancelInactive = () => {
  visibleInactive.value = false;
};
</script>

<style scoped lang="sass"></style>
